import Cookie from 'js-cookie';
export default function setClientTimeCookies() {
    var myDate = new Date();
    Cookie.set("TZClientTimezoneOffset", myDate.getTimezoneOffset().toString());
    Cookie.set("TZClientLoginTime", myDate.getFullYear() +
        "/" +
        (myDate.getMonth() + 1) +
        "/" +
        myDate.getDate() +
        "/" +
        myDate.getHours() +
        "/" +
        myDate.getMinutes() +
        "/" +
        myDate.getSeconds());
}
